import { Form } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import generateRender from 'shared/utils/generateRender';
import theme from 'shared/assets/style/theme';
import { pwaStyleAdapter } from '../../utils/mobileSupported';

// App-custom props funnelled through this input (icon/error layout, password-peeker,
// RN-style flags). They're consumed by wrappers/styles, never valid <input> attributes,
// so filter them here — the single point every text input flows through.
const NON_DOM_INPUT_PROPS = ['icon', 'boxErrorLayout', 'secureTextEntry', 'customClassName', 'customPeekerStyle'];

const TextInputJamul = styled(Form.Control).withConfig({
  shouldForwardProp: prop => !NON_DOM_INPUT_PROPS.includes(prop),
})`
  background: ${theme.palette.primary[32]};
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 0.6em;
  height: ${pwaStyleAdapter(42, 'px')};
  color: ${theme.palette.common[1]};
  padding-left: ${({ icon }) => pwaStyleAdapter(icon ? 30 : 10, 'px')};
  font-size: ${pwaStyleAdapter(1, 'rem')};
  ::placeholder,
  ::-webkit-input-placeholder {
    font-size: ${pwaStyleAdapter(1, 'rem')};
    color: ${theme.palette.common[1]};
  }
  &:focus {
    box-shadow: none;
    outline: none;
    background: ${theme.palette.primary[32]};
    border-radius: 0.6em;
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: ${theme.palette.common[1]};
    outline: none;
    box-shadow: none;
    font-size: ${pwaStyleAdapter(1, 'rem')};
  }

  ${({ error, boxErrorLayout }) => error && boxErrorLayout && BoxErrorLayout}
`;

const BoxErrorLayout = css`
  border-bottom-left-radius: 0.6em;
  border-bottom-right-radius: 0.6em;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-top: none;
  &:focus {
    border-bottom-left-radius: 0.6em;
    border-bottom-right-radius: 0.6em;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-top: none;
  }
`;

export const TextInputBootstrap = generateRender({
  default: TextInputJamul,
});

